import { useEffect } from 'react';
import { useNavigate, useSearchParams } from 'react-router-dom';

/**
 * Backward compatibility redirect for old /signup?ref=CODE links
 * Redirects to new /invite?ref=CODE page
 */
function SignupRedirect() {
  const navigate = useNavigate();
  const [searchParams] = useSearchParams();

  useEffect(() => {
    const refCode = searchParams.get('ref');
    if (refCode) {
      navigate(`/invite?ref=${refCode}`, { replace: true });
    } else {
      navigate('/events', { replace: true });
    }
  }, [searchParams, navigate]);

  return null;
}

export default SignupRedirect;
